import React, { lazy } from 'react'
const Campaign = lazy(() => import('./campaign'))

const AdCampaign = () => {

    return <Campaign />
}

export default AdCampaign